import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5c53f704&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c53f704"]])

export default __exports__